
/**
 * @nullable
 */
export type ArticleModelLifeCycleCode = typeof ArticleModelLifeCycleCode[keyof typeof ArticleModelLifeCycleCode] | null;


export const ArticleModelLifeCycleCode = {
  I: 'I',
  G: 'G',
  P: 'P',
  O: 'O',
  E: 'E',
  N: 'N',
  NA: 'NA',
} as const;
